import React from 'react';
import styles from './index.module.less';
import { Button, Space } from 'antd';

const V2FilterFooter: React.FC<any> = ({
  handleSearch,
  clearFiltersAndClose,
}) => {
  return (
    <Space className={styles.V2TableFilterFooter}>
      <Button
        className={styles.V2TableFilterFooterBtn}
        type='primary'
        onClick={handleSearch}
        size='small'
      >
        确定
      </Button>
      <Button
        className={styles.V2TableFilterFooterBtn}
        onClick={clearFiltersAndClose}
        size='small'
      >
        清空
      </Button>
    </Space>
  );
};

export default V2FilterFooter;
